import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toggleI18n } from '../../features/someFunctionality/funSlice';
import AccountMenu from './AccountMenu';

const NavTop = ({ isSticky }) => {
    const { userInfo } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const { i18n } = useTranslation();

    function changeLanguage(e) {
        i18n.changeLanguage(e.target.value);
        dispatch(toggleI18n(e.target.value));
    }

    const { i18n: newI18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (newI18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [newI18n]);

    return (
        <div id={`${isSticky ? 'topNav-fixd' : 'topNav-0'}`} className='transition duration-300 hidden xl:block'>
            <div className='bg-bnd-4 grid'>
                <div className='xl:container mx-auto xl:px-20 px-5 h-8 font-poppins'>
                    <div className="flex">
                        <div className='adres grow flex py-2 space-x-3 text-xs pr-40'>
                            <p className='space-x-1'>
                                <i className="fa fa-phone font-bold" aria-hidden="true"></i>
                                <span>+88 01841 28 29 20</span>
                            </p>
                            <p className='space-x-1'>
                                <i className="fa fa-envelope-o font-bold" aria-hidden="true"></i>
                                <span> info@deerparfum.com</span>
                            </p>
                        </div>
                        {userInfo?.email ?
                            <div className='grow flex'>
                                <p className='focus:outline-none color-bnd-1 px-3 py-1 flex gap-1'>
                                    <AccountMenu userInfo={userInfo} />
                                </p>
                            </div>
                            :
                            <div className='grow flex'>
                                <p className='focus:outline-none color-bnd-1 px-3 py-1 flex gap-1'>
                                    <Link className='hover:text-inherit' to="/auth/register">{translate ? "SIGNUP" : "রেজিস্টেশন"}</Link> / <Link className='hover:text-inherit' to="/auth">{translate ? "LOGIN" : "লগইন"}</Link>
                                </p>
                            </div>
                        }

                        <div className='flex-none flex'>
                            <button onClick={changeLanguage} value='en' className='focus:outline-none border-r border-l border-amber-600 grid content-center color-bnd-1 px-3'>
                                English
                            </button>
                            <button onClick={changeLanguage} value='bn' className='focus:outline-none border-r border-l border-amber-600 grid content-center color-bnd-1 px-3'>
                                বাংলা
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NavTop;